export default {
    "name": "Login",
    "kind": "HoudiniMutation",
    "hash": "1d040fc08e138cf6514b58a3d7fd1652c8592655545492f8b63192a1768a015c",

    "raw": `mutation Login($userName: String!, $passPhrase: String!, $storeId: UInt!) {
  createSession(user: $userName, password: $passPhrase, storeId: $storeId) {
    token
    id
    userName
    currentUserAccountId
    accessType
    accessStatus
    sessionStatus
    storeId
    recordType
    recordId
    ...Permissions
    companyInfo {
      id
    }
    userAccount {
      ...SessionUserAccount
      id
    }
  }
}

fragment Permissions on Session {
  permissions {
    CONFIGURATION_CAN_CONFIGURE_STORES
    CUSTOMERS_CAN_ADD
    CUSTOMERS_CAN_EDIT_ADDRESSES
    CUSTOMERS_CAN_EDIT_ADVANCED
    CUSTOMERS_CAN_EDIT_BILLING_ADDRESS
    CUSTOMERS_CAN_EDIT_CREDIT_LIMIT
    CUSTOMERS_CAN_EDIT_CUSTOMERS
    CUSTOMERS_CAN_EDIT_PRICING
    CUSTOMERS_CAN_EDIT_SALESMAN_STORE
    CUSTOMERS_CAN_EDIT_TERMS
    CUSTOMERS_CAN_MANAGE_MESSAGES
    CUSTOMERS_CAN_MANAGE_OPTIONS
    CUSTOMERS_CAN_MANAGE_UNITS
    CUSTOMERS_CAN_MERGE
    DASHBOARD_CHART_EDIT
    DASHBOARD_CHART_EDIT_QUERY
    DASHBOARD_REPORT_EDIT_ALL
    DASHBOARD_REPORT_EDIT_OWN
    DASHBOARD_REPORT_VIEW
    GLOBAL_USER_ADMINISTRATOR
    INTERCHANGE_CAN_OPEN_SCREEN
    PART_CONFIGURATION_CAN_EDIT_PART_TYPES
    PARTS_CAN_CLONE_PARTS
    PARTS_CAN_CREATE_CONDITIONS
    PARTS_CAN_EDIT_ATTACHMENTS
    PARTS_CAN_EDIT_COST
    PARTS_CAN_EDIT_GLCATEGORY
    PARTS_CAN_EDIT_INFO
    PARTS_CAN_EDIT_LOCATION
    PARTS_CAN_EDIT_PRICES
    PARTS_CAN_EDIT_QUANTITY
    PARTS_CAN_EDIT_STATUS
    PARTS_CAN_EDIT_STOCKING_DATA
    PARTS_CAN_REPLICATE_PARTS
    PARTS_CAN_SAVE_PARTS
    PARTS_CAN_VIEW_COST
    PARTS_CAN_VIEW_PARTS
    PARTS_EDIT_RESTRICTED_PART_TYPE_PRICES
    PARTS_EDIT_RESTRICTED_PURCHASE_VENDOR
    PURCHASE_ORDERS_CAN_VIEW
    SALES_ORDERS_CAN_CHANGE_DATE
    SALES_ORDERS_CAN_EDIT
    SALES_ORDERS_CAN_VIEW
    SEARCH_CAN_SEARCH_VEHICLES
    SETTINGS_GROUP_ADMINISTRATOR
    TRANSFER_ORDERS_CAN_VIEW
    VEHICLES_CAN_CHANGE_STOCK_QUANTITY
    VEHICLES_CAN_EDIT_ADDITIONAL_INFORMATION
    VEHICLES_CAN_EDIT_ATTACHMENTS
    VEHICLES_CAN_EDIT_BASIC
    VEHICLES_CAN_EDIT_BIDS
    VEHICLES_CAN_EDIT_GL_CATEGORY
    VEHICLES_CAN_EDIT_NON_BID_UNITS
    VEHICLES_CAN_EDIT_QANDA
    VEHICLES_CAN_EDIT_STATUS
    VEHICLES_CAN_EDIT_STOCK_NUMBER
    VEHICLES_CAN_EDIT_WHOLE_UNIT_ADVANCED
    VEHICLES_CAN_EDIT_WHOLE_UNITS
    VEHICLES_CAN_VIEW_VEHICLE_PERFORMANCE
    VENDORS_CAN_EDIT_VENDORS
    VENDORS_CAN_MERGE
    WEB_CAN_LOGIN
    WORK_ORDERS_CAN_VIEW
  }
  id
  __typename
}

fragment SessionUserAccount on UserAccount {
  id
  username: name
  email: workEmail
  wageRateId
  deliveryZoneId
  glDepartmentId
  driver
  salesPerson
  worker
  firstName
  lastName
  recoveryEmail
  groups {
    id
    name
  }
  stores
  highestAccessPermissions {
    id
    codeName
    category
    description
    level
  }
  settings {
    preferences {
      optInToTestingFeatures
    }
  }
  authorizedStores {
    id
    name
    code
  }
  __typename
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "createSession": {
                "type": "Session",
                "keyRaw": "createSession(password: $passPhrase, storeId: $storeId, user: $userName)",

                "selection": {
                    "fields": {
                        "permissions": {
                            "type": "SessionPermissions",
                            "keyRaw": "permissions",

                            "selection": {
                                "fields": {
                                    "CONFIGURATION_CAN_CONFIGURE_STORES": {
                                        "type": "Boolean",
                                        "keyRaw": "CONFIGURATION_CAN_CONFIGURE_STORES",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_ADD": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_ADD",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_ADDRESSES": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_ADDRESSES",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_ADVANCED": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_ADVANCED",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_BILLING_ADDRESS": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_BILLING_ADDRESS",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_CREDIT_LIMIT": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_CREDIT_LIMIT",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_CUSTOMERS": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_CUSTOMERS",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_PRICING": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_PRICING",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_SALESMAN_STORE": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_SALESMAN_STORE",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_EDIT_TERMS": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_EDIT_TERMS",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_MANAGE_MESSAGES": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_MANAGE_MESSAGES",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_MANAGE_OPTIONS": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_MANAGE_OPTIONS",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_MANAGE_UNITS": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_MANAGE_UNITS",
                                        "visible": true
                                    },

                                    "CUSTOMERS_CAN_MERGE": {
                                        "type": "Boolean",
                                        "keyRaw": "CUSTOMERS_CAN_MERGE",
                                        "visible": true
                                    },

                                    "DASHBOARD_CHART_EDIT": {
                                        "type": "Boolean",
                                        "keyRaw": "DASHBOARD_CHART_EDIT",
                                        "visible": true
                                    },

                                    "DASHBOARD_CHART_EDIT_QUERY": {
                                        "type": "Boolean",
                                        "keyRaw": "DASHBOARD_CHART_EDIT_QUERY",
                                        "visible": true
                                    },

                                    "DASHBOARD_REPORT_EDIT_ALL": {
                                        "type": "Boolean",
                                        "keyRaw": "DASHBOARD_REPORT_EDIT_ALL",
                                        "visible": true
                                    },

                                    "DASHBOARD_REPORT_EDIT_OWN": {
                                        "type": "Boolean",
                                        "keyRaw": "DASHBOARD_REPORT_EDIT_OWN",
                                        "visible": true
                                    },

                                    "DASHBOARD_REPORT_VIEW": {
                                        "type": "Boolean",
                                        "keyRaw": "DASHBOARD_REPORT_VIEW",
                                        "visible": true
                                    },

                                    "GLOBAL_USER_ADMINISTRATOR": {
                                        "type": "Boolean",
                                        "keyRaw": "GLOBAL_USER_ADMINISTRATOR",
                                        "visible": true
                                    },

                                    "INTERCHANGE_CAN_OPEN_SCREEN": {
                                        "type": "Boolean",
                                        "keyRaw": "INTERCHANGE_CAN_OPEN_SCREEN",
                                        "visible": true
                                    },

                                    "PART_CONFIGURATION_CAN_EDIT_PART_TYPES": {
                                        "type": "Boolean",
                                        "keyRaw": "PART_CONFIGURATION_CAN_EDIT_PART_TYPES",
                                        "visible": true
                                    },

                                    "PARTS_CAN_CLONE_PARTS": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_CLONE_PARTS",
                                        "visible": true
                                    },

                                    "PARTS_CAN_CREATE_CONDITIONS": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_CREATE_CONDITIONS",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_ATTACHMENTS": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_ATTACHMENTS",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_COST": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_COST",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_GLCATEGORY": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_GLCATEGORY",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_INFO": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_INFO",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_LOCATION": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_LOCATION",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_PRICES": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_PRICES",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_QUANTITY": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_QUANTITY",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_STATUS": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_STATUS",
                                        "visible": true
                                    },

                                    "PARTS_CAN_EDIT_STOCKING_DATA": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_EDIT_STOCKING_DATA",
                                        "visible": true
                                    },

                                    "PARTS_CAN_REPLICATE_PARTS": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_REPLICATE_PARTS",
                                        "visible": true
                                    },

                                    "PARTS_CAN_SAVE_PARTS": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_SAVE_PARTS",
                                        "visible": true
                                    },

                                    "PARTS_CAN_VIEW_COST": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_VIEW_COST",
                                        "visible": true
                                    },

                                    "PARTS_CAN_VIEW_PARTS": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_CAN_VIEW_PARTS",
                                        "visible": true
                                    },

                                    "PARTS_EDIT_RESTRICTED_PART_TYPE_PRICES": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_EDIT_RESTRICTED_PART_TYPE_PRICES",
                                        "visible": true
                                    },

                                    "PARTS_EDIT_RESTRICTED_PURCHASE_VENDOR": {
                                        "type": "Boolean",
                                        "keyRaw": "PARTS_EDIT_RESTRICTED_PURCHASE_VENDOR",
                                        "visible": true
                                    },

                                    "PURCHASE_ORDERS_CAN_VIEW": {
                                        "type": "Boolean",
                                        "keyRaw": "PURCHASE_ORDERS_CAN_VIEW",
                                        "visible": true
                                    },

                                    "SALES_ORDERS_CAN_CHANGE_DATE": {
                                        "type": "Boolean",
                                        "keyRaw": "SALES_ORDERS_CAN_CHANGE_DATE",
                                        "visible": true
                                    },

                                    "SALES_ORDERS_CAN_EDIT": {
                                        "type": "Boolean",
                                        "keyRaw": "SALES_ORDERS_CAN_EDIT",
                                        "visible": true
                                    },

                                    "SALES_ORDERS_CAN_VIEW": {
                                        "type": "Boolean",
                                        "keyRaw": "SALES_ORDERS_CAN_VIEW",
                                        "visible": true
                                    },

                                    "SEARCH_CAN_SEARCH_VEHICLES": {
                                        "type": "Boolean",
                                        "keyRaw": "SEARCH_CAN_SEARCH_VEHICLES",
                                        "visible": true
                                    },

                                    "SETTINGS_GROUP_ADMINISTRATOR": {
                                        "type": "Boolean",
                                        "keyRaw": "SETTINGS_GROUP_ADMINISTRATOR",
                                        "visible": true
                                    },

                                    "TRANSFER_ORDERS_CAN_VIEW": {
                                        "type": "Boolean",
                                        "keyRaw": "TRANSFER_ORDERS_CAN_VIEW",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_CHANGE_STOCK_QUANTITY": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_CHANGE_STOCK_QUANTITY",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_ADDITIONAL_INFORMATION": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_ADDITIONAL_INFORMATION",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_ATTACHMENTS": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_ATTACHMENTS",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_BASIC": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_BASIC",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_BIDS": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_BIDS",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_GL_CATEGORY": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_GL_CATEGORY",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_NON_BID_UNITS": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_NON_BID_UNITS",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_QANDA": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_QANDA",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_STATUS": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_STATUS",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_STOCK_NUMBER": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_STOCK_NUMBER",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_WHOLE_UNIT_ADVANCED": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_WHOLE_UNIT_ADVANCED",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_EDIT_WHOLE_UNITS": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_EDIT_WHOLE_UNITS",
                                        "visible": true
                                    },

                                    "VEHICLES_CAN_VIEW_VEHICLE_PERFORMANCE": {
                                        "type": "Boolean",
                                        "keyRaw": "VEHICLES_CAN_VIEW_VEHICLE_PERFORMANCE",
                                        "visible": true
                                    },

                                    "VENDORS_CAN_EDIT_VENDORS": {
                                        "type": "Boolean",
                                        "keyRaw": "VENDORS_CAN_EDIT_VENDORS",
                                        "visible": true
                                    },

                                    "VENDORS_CAN_MERGE": {
                                        "type": "Boolean",
                                        "keyRaw": "VENDORS_CAN_MERGE",
                                        "visible": true
                                    },

                                    "WEB_CAN_LOGIN": {
                                        "type": "Boolean",
                                        "keyRaw": "WEB_CAN_LOGIN",
                                        "visible": true
                                    },

                                    "WORK_ORDERS_CAN_VIEW": {
                                        "type": "Boolean",
                                        "keyRaw": "WORK_ORDERS_CAN_VIEW",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        },

                        "token": {
                            "type": "String",
                            "keyRaw": "token",
                            "nullable": true,
                            "visible": true
                        },

                        "userName": {
                            "type": "String",
                            "keyRaw": "userName",
                            "nullable": true,
                            "visible": true
                        },

                        "currentUserAccountId": {
                            "type": "Int",
                            "keyRaw": "currentUserAccountId",
                            "nullable": true,
                            "visible": true
                        },

                        "accessType": {
                            "type": "String",
                            "keyRaw": "accessType",
                            "nullable": true,
                            "visible": true
                        },

                        "accessStatus": {
                            "type": "String",
                            "keyRaw": "accessStatus",
                            "nullable": true,
                            "visible": true
                        },

                        "sessionStatus": {
                            "type": "String",
                            "keyRaw": "sessionStatus",
                            "nullable": true,
                            "visible": true
                        },

                        "storeId": {
                            "type": "UInt",
                            "keyRaw": "storeId",
                            "nullable": true,
                            "visible": true
                        },

                        "recordType": {
                            "type": "String",
                            "keyRaw": "recordType",
                            "nullable": true,
                            "visible": true
                        },

                        "recordId": {
                            "type": "Int",
                            "keyRaw": "recordId",
                            "nullable": true,
                            "visible": true
                        },

                        "companyInfo": {
                            "type": "Company",
                            "keyRaw": "companyInfo",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "userAccount": {
                            "type": "UserAccount",
                            "keyRaw": "userAccount",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "username": {
                                        "type": "String",
                                        "keyRaw": "username",
                                        "visible": true
                                    },

                                    "email": {
                                        "type": "String",
                                        "keyRaw": "email",
                                        "visible": true
                                    },

                                    "wageRateId": {
                                        "type": "UInt",
                                        "keyRaw": "wageRateId",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "deliveryZoneId": {
                                        "type": "UInt",
                                        "keyRaw": "deliveryZoneId",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "glDepartmentId": {
                                        "type": "UInt",
                                        "keyRaw": "glDepartmentId",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "driver": {
                                        "type": "Boolean",
                                        "keyRaw": "driver",
                                        "visible": true
                                    },

                                    "salesPerson": {
                                        "type": "Boolean",
                                        "keyRaw": "salesPerson",
                                        "visible": true
                                    },

                                    "worker": {
                                        "type": "Boolean",
                                        "keyRaw": "worker",
                                        "visible": true
                                    },

                                    "firstName": {
                                        "type": "String",
                                        "keyRaw": "firstName",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "lastName": {
                                        "type": "String",
                                        "keyRaw": "lastName",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "recoveryEmail": {
                                        "type": "String",
                                        "keyRaw": "recoveryEmail",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "groups": {
                                        "type": "Group",
                                        "keyRaw": "groups",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "stores": {
                                        "type": "UInt",
                                        "keyRaw": "stores",
                                        "visible": true
                                    },

                                    "highestAccessPermissions": {
                                        "type": "UserAccountPermission",
                                        "keyRaw": "highestAccessPermissions",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "codeName": {
                                                    "type": "String",
                                                    "keyRaw": "codeName",
                                                    "visible": true
                                                },

                                                "category": {
                                                    "type": "String",
                                                    "keyRaw": "category",
                                                    "visible": true
                                                },

                                                "description": {
                                                    "type": "String",
                                                    "keyRaw": "description",
                                                    "visible": true
                                                },

                                                "level": {
                                                    "type": "PermissionLevel",
                                                    "keyRaw": "level",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "settings": {
                                        "type": "UserSettings",
                                        "keyRaw": "settings",

                                        "selection": {
                                            "fields": {
                                                "preferences": {
                                                    "type": "UserSettingsPreferencesCategory",
                                                    "keyRaw": "preferences",

                                                    "selection": {
                                                        "fields": {
                                                            "optInToTestingFeatures": {
                                                                "type": "Boolean",
                                                                "keyRaw": "optInToTestingFeatures",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "authorizedStores": {
                                        "type": "Store",
                                        "keyRaw": "authorizedStores",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "code": {
                                                    "type": "String",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "SessionUserAccount": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        }
                    },

                    "fragments": {
                        "Permissions": {
                            "arguments": {}
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "userName": "String",
            "passPhrase": "String",
            "storeId": "UInt"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=dcd129a1a826a39b1d1d34db0759a6bbc81ec98b8db255279bfb1e4580902576";